export const storageMap: { [account: string]: number } = {
  none: 0,
  '0x01': 0,
  '0x02': 1,
  '0x03': 2,
  '0x04': 3,
  '0x05': 4,
};
